import React from 'react'

export default function ThumbsUp() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="22" viewBox="0 0 26 22">
      <path id="ap_user_like" d="M23.777,2.192a7.611,7.611,0,0,0-10.79,0,7.611,7.611,0,0,0-10.79,0,7.447,7.447,0,0,0,0,10.664l9.491,8.571a1.873,1.873,0,0,0,2.6,0l9.491-8.571A7.628,7.628,0,0,0,23.777,2.192Z" transform="translate(0.05 0.05)" fill="#e52e66"/>
    </svg>
  )
}
